import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { SimpleDashboardContent } from 'features/dashboard/DashboardContent';
import { DashboardHeader } from 'features/dashboard/dashboard-header/DashboardHeader';
import { GenericLoading } from 'components/ui/Loader';
import { ErrorState } from 'components/ui/EmptyState';
import { GetAssureDetailsResponse } from 'api/actor';
import { actorsAPI } from 'services/swagger-api';
import PersonDetailsLayout from './PersonDetailsLayout';
import { PersonContent } from './PersonContent';

const PersonDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const [personDetails, setPersonDetails] = useState<GetAssureDetailsResponse>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(false);

  const fetchPersonDetails = useCallback(async (personId: string) => {
    setIsLoading(true);
    setHasError(false);
    try {
      const response = await actorsAPI.getInsuredDetails({ personneId: personId });
      if (response) {
        setPersonDetails(response);
      } else {
        setHasError(true);
      }
    } catch (error) {
      console.error('Error fetching person details:', error);
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (id) {
      fetchPersonDetails(id);
    }
  }, [id, fetchPersonDetails]);

  if (isLoading) {
    return <GenericLoading loading isFullPage />;
  }

  if (hasError || !personDetails) {
    return (
      <SimpleDashboardContent>
        <DashboardHeader />
        <ErrorState
          title='Impossible de charger la fiche client'
          message='Les informations de ce client sont indisponibles pour le moment.'
          onRetry={id ? () => fetchPersonDetails(id) : undefined}
        />
      </SimpleDashboardContent>
    );
  }

  return (
    <SimpleDashboardContent>
      <DashboardHeader />
      <PersonDetailsLayout personDetails={personDetails}>
        <PersonContent personDetails={personDetails} personId={id!} />
      </PersonDetailsLayout>
    </SimpleDashboardContent>
  );
};

export default PersonDetails;
